import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  crumbs: {
    '& .MuiBreadcrumbs-separator': {
      color: theme.palette.darkGrey,
      fontSize: 18,
      fontWeight: 700,
      '&:nth-last-child(2)': {
        color: theme.palette.grey2,
      },
    },
  },
  link: {
    color: theme.palette.darkGrey,
    fontSize: 18,
    fontWeight: 700,
    textDecoration: 'none',
  },
  activeLink: {
    color: theme.palette.grey2,
  },
}));
